__turbopack_context__.v({
  "blocksBackgroundColor": "LoginButtons-module-scss-module__ZeKQ1q__blocksBackgroundColor",
  "blocksFontColor": "LoginButtons-module-scss-module__ZeKQ1q__blocksFontColor",
  "loginButton": "LoginButtons-module-scss-module__ZeKQ1q__loginButton",
  "loginButtonFacebook": "LoginButtons-module-scss-module__ZeKQ1q__loginButtonFacebook",
  "loginButtonGoogle": "LoginButtons-module-scss-module__ZeKQ1q__loginButtonGoogle",
  "loginButtonLogo": "LoginButtons-module-scss-module__ZeKQ1q__loginButtonLogo",
  "loginButtonLogoContainer": "LoginButtons-module-scss-module__ZeKQ1q__loginButtonLogoContainer",
  "loginButtonLogoFacebook": "LoginButtons-module-scss-module__ZeKQ1q__loginButtonLogoFacebook",
  "loginButtonLogoGoogle": "LoginButtons-module-scss-module__ZeKQ1q__loginButtonLogoGoogle",
  "loginButtonLogoOffice": "LoginButtons-module-scss-module__ZeKQ1q__loginButtonLogoOffice",
  "loginButtonLogoPassport": "LoginButtons-module-scss-module__ZeKQ1q__loginButtonLogoPassport",
  "loginButtonOffice": "LoginButtons-module-scss-module__ZeKQ1q__loginButtonOffice",
  "loginButtonPassport": "LoginButtons-module-scss-module__ZeKQ1q__loginButtonPassport",
  "loginButtonText": "LoginButtons-module-scss-module__ZeKQ1q__loginButtonText",
  "loginButtonTextFacebook": "LoginButtons-module-scss-module__ZeKQ1q__loginButtonTextFacebook",
  "loginButtonTextGoogle": "LoginButtons-module-scss-module__ZeKQ1q__loginButtonTextGoogle",
  "loginButtonTextOffice": "LoginButtons-module-scss-module__ZeKQ1q__loginButtonTextOffice",
  "loginButtonTextPassport": "LoginButtons-module-scss-module__ZeKQ1q__loginButtonTextPassport",
  "loginButtonsContainer": "LoginButtons-module-scss-module__ZeKQ1q__loginButtonsContainer",
  "magicLinkButton": "LoginButtons-module-scss-module__ZeKQ1q__magicLinkButton",
  "magicLinkError": "LoginButtons-module-scss-module__ZeKQ1q__magicLinkError",
  "magicLinkForm": "LoginButtons-module-scss-module__ZeKQ1q__magicLinkForm",
  "magicLinkInput": "LoginButtons-module-scss-module__ZeKQ1q__magicLinkInput",
  "magicLinkSeparator": "LoginButtons-module-scss-module__ZeKQ1q__magicLinkSeparator",
  "magicLinkSuccess": "LoginButtons-module-scss-module__ZeKQ1q__magicLinkSuccess",
  "secondaryNavBackgroundColor": "LoginButtons-module-scss-module__ZeKQ1q__secondaryNavBackgroundColor",
  "themeBackgroundColor": "LoginButtons-module-scss-module__ZeKQ1q__themeBackgroundColor",
  "themeFontColor": "LoginButtons-module-scss-module__ZeKQ1q__themeFontColor",
  "themeFontFamily": "LoginButtons-module-scss-module__ZeKQ1q__themeFontFamily",
});
